import { Component, input, output } from '@angular/core';
import { Device } from '@rocksoft/shared';
import { DeviceGridItemContainerComponent } from './device-grid-item.container';

@Component({
  selector: 'era-device-grid-ui',
  templateUrl: './device-grid.component.html',
  imports: [DeviceGridItemContainerComponent],
})
export class DeviceGridComponent {
  readonly devices = input<Device[]>([]);
  readonly selected = output<Device>();

  public select(device: Device) {
    this.selected.emit(device);
  }
}
